module.exports = __webpack_public_path__ + "img/frame (147).95e59c59.jpg";